import { Component, Input, OnInit } from '@angular/core';
import 'rxjs/add/operator/first';
import { ObservationModel } from '../../models/observation.model';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObservationService } from '../../services/observation.service';
import { AuthenticationService, ToastService2, ToolbarService } from '@kaiser-software/chassis-core';

@Component({
    selector: 'eyewatch-observation-status-plugin',
    templateUrl: 'status.plugin.html',
    styleUrls: ['status.plugin.scss']
})
export class StatusPlugin implements OnInit {

    @Input() public model: Subject<ObservationModel>;

    public observation$: Subject<ObservationModel>;

    protected subscription = new Subscription();

    constructor(
        protected observationService: ObservationService,
        protected authenticationService: AuthenticationService,
        protected toastService: ToastService2,
        protected toolbarService: ToolbarService) {
    }

    public ngOnInit(): void {
        this.observation$ = this.model;

        this.observation$.subscribe((observation) => {
            console.log(observation);
        });
    }

    public isStatusOpen(): Observable<boolean> {
        return this.observation$
            .pipe(
                map((observation: ObservationModel) => {
                    return observation.getStatus() === 'open';
                })
            );
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/plugins/status/status.plugin.ts